import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { CssBaseline } from "@mui/material";
import { Top } from "./pages/Top";
import { Fungi } from "./pages/Fungi";
import { Company } from "./pages/Company";
import { Footer } from "./components/Footer";
import { Service } from "./pages/Service";
import { Technology } from "./pages/Technology";
import { News } from "./pages/News";
import { NewsDetail } from "./pages/NewsDetail";
import { Contact } from "./pages/Contact";
import { Header } from "./components/Header";
import { Privacy } from "./pages/Privacy";

const App = () => {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#006400",
      },
      secondary: {
        main: "#ffbd00",
      },
    },
    typography: {
      fontFamily: '"Noto Sans JP", serif',
      fontSize: 20,
      h1: {
        fontFamily: '"A1", Arial, sans-serif',
        fontWeight: 500,
        fontSize: 64,
        "@media (max-width:840px)": {
          fontSize: 32,
        },
      },
      h2: {
        fontFamily: '"A1", Arial, sans-serif',
        fontWeight: 500,
        fontSize: 64,
        "@media (max-width:840px)": {
          fontSize: 32,
        },
      },
      h3: {
        fontFamily: '"A1", Arial, sans-serif',
        fontWeight: 500,
        fontSize: 32,
        "@media (max-width:840px)": {
          fontSize: 18,
        },
      },
      h4: {
        fontFamily: '"A1", Arial, sans-serif',
        fontWeight: 500,
        fontSize: 28,
        "@media (max-width:840px)": {
          fontSize: 16,
        },
      },
      body1: {
        fontSize: 16,
        "@media (max-width:840px)": {
          fontSize: 14,
        },
      },
    },
    spacing: 10,
    breakpoints: {
      values: {
        xs: 0,
        sm: 840,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
    components: {
      MuiContainer: {
        defaultProps: {
          maxWidth: "lg",
        },
        styleOverrides: {
          root: {
            maxWidth: "1200px",
            padding: "60px 30px",
            "@media (max-width:840px)": {
              padding: "30px 20px",
            },
          },
        },
      },

      MuiButton: {
        styleOverrides: {
          root: {
            fontFamily: '"Noto Sans JP", serif',
            borderRadius: 999,
            padding: "16px 43px",
            fontSize: "16px",
            lineHeight: 1,
            textTransform: "none",
            "@media (max-width:840px)": {
              padding: "14px 43px",
            },
          },
        },
      },
    },
  });

  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      return;
    }
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <Header />
        <main>
          <CssBaseline />
          <Routes>
            <Route path="/" element={<Top />} />
            <Route path="/fungi" element={<Fungi />} />
            <Route path="/service" element={<Service />} />
            <Route path="/company" element={<Company />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>
        <Footer />
      </ThemeProvider>
    </div>
  );
};

export default App;
